import { getHttpClient } from '../axiosInstance'

const base = '/vendor/qa/v1'

export const fetchWithPagination = async (queryParams) => {
  const apiClient = getHttpClient()
  const url = `${base}/`
  /**
   * Add hidden parameters to make the API call
   */
  const hiddenParams = {}

  /**
   * It's also possible to remove and sanitize some parameters
   */
  const customQueryParams = { ...queryParams, ...hiddenParams }

  const response = await apiClient.get(url, { params: customQueryParams })
  return response.data
}

export const accept = async (id) => {
  const apiClient = getHttpClient()

  const url = `${base}/${id}/accept`
  const response = await apiClient.put(url, {})
  return response.data
}

export const downloadScorecard = async ({ id, name }) => {
  const apiClient = getHttpClient()

  const url = `${base}/${id}/scorecard`
  const response = await apiClient.get(url, { responseType: 'arraybuffer' })

  const anchorUrl = window.URL.createObjectURL(new Blob([response.data]))
  const link = document.createElement('a')
  link.href = anchorUrl
  link.setAttribute('download', `${name}`)
  document.body.appendChild(link)
  link.click()

  return null // response.data
}
